import type { Column } from "@/types/array.types";

interface LogsTableProps<T> {
    columns: Column<T>[];
    dataArray: T[];

}

export function LogsTable<T extends Record<string, any>>({columns, dataArray}: LogsTableProps<T>) {
    return <table>
    <thead className={"table-header"}>
        <tr>
        {columns.map((column, index) => {
            return  <th key={`header_${index}`}> {column.label}</th>
        })}
        </tr>
    </thead>
    <tbody className={"table-body"}>
        {dataArray?.map((data, rowIndex) => (
          <tr className="table-row" key={rowIndex}>
            {columns.map((column, colIndex) => (
              column.key != "id" &&
              <td key={colIndex}>
                 {column.render
                    ? column.render(data)
                    : String(data[column.key])}              
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    
};